import { EmployeePosition, SessionDashboardEducator } from "../../../api/PartnerPortalGatewayApi";

// Grouping/sorting logic lives in a single shared location (utils/educatorGrouping) so the
// Session Dashboard and Team Members page can't drift out of sync. Re-exported here to avoid
// churning existing imports across the codebase.
export { groupAndSortEducators } from "../../../utils/educatorGrouping";

export const toEmployeePosition = (educator: SessionDashboardEducator): EmployeePosition => {
  const nameParts = educator.employeeName?.split(" ") ?? [];
  return new EmployeePosition({
    employeeId: educator.employeeId,
    firstName: nameParts[0],
    lastName: nameParts.slice(1).join(" "),
    positionId: 0,
    positionName: educator.positionName,
    wwccReferences: educator.wwccReferences,
  });
};
